import styled from "styled-components";
import { Flex, Text } from "rebass/styled-components";

export const SectionWrapper = styled(Flex)`
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin-top: 16px;
`;

export const MoreWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const MoreHeading = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
`;

export const MoreRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    grid-template-columns: 1fr;
  }
`;
